import { render, staticRenderFns } from "./OpenTickets.vue?vue&type=template&id=69541dd9&scoped=true"
import script from "./OpenTickets.vue?vue&type=script&lang=js"
export * from "./OpenTickets.vue?vue&type=script&lang=js"
import style1 from "./OpenTickets.vue?vue&type=style&index=1&id=69541dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69541dd9",
  null
  
)

export default component.exports